(function (angular) {
    angular.module('bizPartEngage').controller('core.themestest', themestestController);

    themestestController.$inject = ['$rootScope'];

    function themestestController($rootScope) {
        var vm = this;

        vm.Init = Init;
        vm.TriggerHubEvent = TriggerHubEvent;

        function TriggerHubEvent(eventKey = '', val = '') {
            let params = {
                Content: {}
            };

            if (eventKey == 'HUB_NEW_CERTIFICATE') {
                params = {
                    Content: {
                        Name: 'test 12345 HUB_NEW_CERTIFICATE',
                        Cert: {
                            UserData: {
                                UserCertId: -1
                            }
                        }
                    }
                };
            }
            else if (eventKey == 'HUB_LEVEL_GAIN') {
                params = {
                    Content: {
                        Name: 'test 12345'
                    }
                };
            }
            else if (eventKey == 'HUB_NEW_BADGE') {
                params = {
                    Content: {
                        Name: 'New badge unlocked',
                        Description: 'You have completed your first journey.\nKeep going - every step builds progress!',
                        Image: 'https://www.bizpart.com/shared-files/images/badges/badge_onboarded.png',
                        BackgroundImage: 'https://www.bizpart.com/shared-files/images/badges/badge_bg.png'

                    }
                };
            }
            else if (eventKey == 'HUB_EXPERIENCE_UPDATE_DEFAULT') {
                let pointsToAdd = parseInt(val);
                params = {
                    Content: $rootScope.LoggedInUser.DefaultExperiencePoints += pointsToAdd,
                };
            }
            else if (eventKey == 'HUB_EXPERIENCE_GAIN') {
                let pointsToAdd = parseInt(val);
                params = {
                    Content: {
                        TotalExperiencePoints: pointsToAdd,
                    }
                };
            }

            // Dispatch for React (CustomEvent on document for SignalR context)
            var hubKey = eventKey.replace('HUB_', '');
            document.dispatchEvent(new CustomEvent('SignalR.serverMessage', { 
                detail: { 
                    d: { 
                        Content: JSON.stringify(params.Content),
                        HubKey: hubKey, 
                        HubServerName: 'HubGeneric' 
                    } 
                } 
            }));

            // Broadcast for AngularJS ($rootScope)
            $rootScope.$broadcast(eventKey, { Content: JSON.stringify(params.Content) });
        }

        function Init() {
            console.log('ThemesTest init...')
        }

        vm.$onInit = Init;
    }
}(window.angular));